<template>
  <v-container>
    <v-breadcrumbs :items="items" class="mt-3">
      <template v-slot:divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
      <template v-slot:item="{ item }">
        <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
          {{ item.text }}
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>
    <div v-if="productSearch.length !== 0">
      <v-row class="mt-4">
        <v-col cols="5" md="4" class="pa-0" v-if="!MobileSize">
          <span style="font-weight: 700; font-size: 18px; color: #333333;" class="mt-2 ml-3">ค้นพบคำว่า "<span
            style="color: #27AB9C;">{{ textSearch }}</span>" ทั้งหมด {{ productSearch.length }} รายการ</span>
        </v-col>
        <v-col cols="5" md="4" class="pa-0" v-if="MobileSize">
          <span style="font-weight: 700; font-size: 14px; color: #333333;" class="mt-2 ml-3">ค้นพบคำว่า "
            <span style="color: #27AB9C;">{{ textSearch }}</span>"<br />
            <span style="font-weight: 700; font-size: 14px; color: #333333;" class="mt-2 ml-3">ทั้งหมด {{ productSearch.length }} รายการ</span>
          </span>
        </v-col>
      </v-row>
      <v-row justify="start" class="px-0" v-if="!MobileSize">
        <v-col cols="6" md="2" sm="3" xs="4" v-for="(item, index) in paginated" :key="index" class="px-2">
          <CardProducts :itemProduct='item'/>
        </v-col>
      </v-row>
      <v-row dense v-else>
        <v-col cols="6" sm="6" xs="6" v-for="(item, index) in paginated" :key="index" class="mb-4" align="center">
          <CardProductsResponsive :itemProduct='item' style="text-align: left;"/>
        </v-col>
      </v-row>
      <v-row justify="center" class="my-6">
        <v-pagination color="#27AB9C" v-model="pageNumber" :length="pageMax" :total-visible="7" @input="pageChange()">
        </v-pagination>
      </v-row>
    </div>
    <a-row type="flex" justify="center" style="margin-top: 10%; margin-bottom: 10%;" v-else-if="productSearch.length === 0">
      <template>
        <a-empty :image="require('@/assets/Not_Result.png')" :image-style="{height: '200px', marginBottom: '40px'}">
          <h1 slot="description" style="font-weight: bold;">ไม่พบผลการค้นหา</h1>
          <h3 slot="description" style="font-weight: bold;">โปรดตรวจสอบตัวสะกดว่าถูกต้องหรือไม่
            หรือค้นหาโดยใช้คำที่ใกล้เคียง</h3>
          <h3 slot="description" style="font-weight: bold;">กรุณาลองค้นหาใหม่อีกครั้ง</h3>
        </a-empty>
      </template>
    </a-row>
  </v-container>
</template>

<script>
import { Encode, Decode } from '@/services'
const productResult = []
for (let i = 0; i < 20; i++) {
  productResult.push({
    product_id: i,
    name: `Data Title product ${i}`,
    price: ` ${(i + 1) * 100}`,
    stock: `${i}`,
    image: `https://picsum.photos/500/300?image=${i * 5 + 10}`
  })
}
export default {
  metaInfo () {
    return {
      title: this.textSearch + ' ราคาพิเศษ | INET-Marketplace Platform',
      titleTemplate: '%s',
      htmlAttrs: {
        lang: 'th-TH'
      },
      meta: [
        { vmid: 'description', name: 'description', content: this.textSearch + 'สินค้าราคาพิเศษ | INET-Marketplace Platform' },
        { property: 'og:site_name', vmid: 'og:site_name', content: 'https://testinetmarket.one.th' },
        { property: 'og:title', vmid: 'og:title', content: this.textSearch + 'สินค้าราคาพิเศษ | INET-Marketplace Platform' },
        { property: 'og:description', vmid: 'og:description', content: this.textSearch + 'สินค้าราคาพิเศษ | INET-Marketplace Platform' },
        { property: 'og:type', vmid: 'og:type', content: 'website' },
        { property: 'og:url', vmid: 'og:url', content: 'https://testinetmarket.one.th' }
        // { property: 'og:image', name: 'image', content: this.primaryImage },
        // { property: 'og:image:width', content: '640' },
        // { property: 'og:image:height', content: '480' }
      ]
    }
  },
  components: {
    CardProducts: () => import('@/components/Gracz/Sales/Product/ProductCardDesktopProductList'),
    CardProductsResponsive: () => import('@/components/Gracz/Sales/Product/ProductCardResponsive')
  },
  data () {
    return {
      productResult,
      textSearch: '',
      productSearch: [],
      shopSearch: [],
      pageMax: null,
      current: 1,
      pageSize: 24,
      shopCount: null,
      PathImage: process.env.VUE_APP_IMAGE,
      shopSearchShow: [],
      items: [
        {
          text: 'หน้าแรก',
          disabled: false,
          href: '/Order/Product?Header=สินค้าทั้งหมด'
        },
        {
          text: 'ผลการค้นหา',
          disabled: true,
          href: ''
        }
      ],
      itemPrice: [
        { text: 'ทั้งหมด', value: '-' },
        { text: 'ราคา: จากน้อยไปมาก', value: 'lowToHigh' },
        { text: 'ราคา: จากมากไปน้อย', value: 'HighToLow' }
      ]
    }
  },
  created () {
    this.$EventBus.$emit('changeAppBarGracz')
    this.$EventBus.$emit('enableCartGracz')
    this.oneData = []
    if (localStorage.getItem('oneData') === null || localStorage.getItem('UserDetailSelling') === null) {
      this.$router.push({ path: '/' }).catch(() => {})
    } else {
      if (Object.prototype.hasOwnProperty.call(localStorage, 'oneData')) {
        this.oneData = JSON.parse(Decode.decode(localStorage.getItem('oneData')))
      }
      this.items[0].href = '/Order/Product?Header=สินค้าทั้งหมด'
      this.$EventBus.$emit('GraczSearchdata')
      this.$EventBus.$emit('getPath')
      this.pageNumber = 1
      this.getResultSearch()
    }
  },
  computed: {
    pageNumber: {
      get () {
        return this.current || 1
      },
      set (newPage) {
        // You could alternatively call your API here if you have serverside pagination
        this.current = newPage
        window.scrollTo(0, 0)
      }
    },
    indexStart () {
      return (this.current - 1) * this.pageSize
    },
    indexEnd () {
      return this.indexStart + this.pageSize
    },
    paginated () {
      return this.productSearch.slice(this.indexStart, this.indexEnd)
    },
    MobileSize () {
      // console.log('mobile', this.$vuetify.breakpoint)
      const { xs } = this.$vuetify.breakpoint
      return !!xs
    },
    IpadProSize () {
      // console.log('ipad pro w:1024', this.$vuetify.breakpoint)
      const { md } = this.$vuetify.breakpoint
      return !!md
    },
    IpadSize () {
      // console.log('ipad w:768', this.$vuetify.breakpoint)
      const { sm } = this.$vuetify.breakpoint
      return !!sm
    },
    desktopSize () {
      // console.log('ipad w:768', this.$vuetify.breakpoint)
      const { xl } = this.$vuetify.breakpoint
      return !!xl
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$EventBus.$on('getGraczSearchProduct', this.searchNewData)

    this.$on('hook:beforeDestroy', () => {
      this.$EventBus.$off('getGraczSearchProduct')
    })
  },
  methods: {
    searchNewData () {
      this.pageNumber = 1
      this.getResultSearch()
    },
    async getResultSearch () {
      this.$store.commit('openLoader')
      this.textSearch = this.$router.currentRoute.params.data
      var shopData
      var customerData
      if (localStorage.getItem('UserDetailSelling') !== null) {
        shopData = JSON.parse(Decode.decode(localStorage.getItem('UserDetailSelling')))
      }
      if (localStorage.getItem('OnlinePurchase') !== null) {
        customerData = JSON.parse(Decode.decode(localStorage.getItem('OnlinePurchase')))
      }
      var data = {
        seller_shop_id: shopData.seller_shop_id,
        role_user: shopData.position,
        cus_id: customerData.cus_id,
        page: this.pageNumber,
        keyword: this.textSearch
      }
      console.log('data to search Gracz=======>', this.textSearch)
      await this.$store.dispatch('actionsGraczSearchProduct', data)
      var response = await this.$store.state.ModuleGraczProduct.stateGraczSearchProduct
      if (response.message === 'ListProducts success!') {
        this.$store.commit('closeLoader')
        this.productSearch = response.data.products
        this.pageMax = parseInt(this.productSearch.length / 24) === 0 ? 1 : Math.ceil(this.productSearch.length / 24)
        if (this.pageNumber > this.pageMax) {
          this.pageNumber = 1
        }
        // this.shopSearchShow = response.query_result_shop
        // this.shopCount = this.shopSearchShow.length
        if (response.data.products.length === 0) {
          this.productSearch = []
        }
      } else if (response.message === 'This user is unauthorized.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else if (response.message === 'Employee not found.') {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'warning', text: 'ไม่พบพนักงาน', showConfirmButton: false, timer: 2000 })
        window.location.assign('/')
      } else {
        this.$store.commit('closeLoader')
        this.$swal.fire({ icon: 'error', text: response.message, showConfirmButton: false, timer: 2000 })
      }
    },
    pageChange () {
      this.getResultSearch()
    },
    gotoShopDetail (val) {
      const shopCleaned = val[0].name_th.replace(/\s/g, '-')
      this.$router.push(`/shoppage/${shopCleaned}-${val[0].id}`).catch(() => {})
    },
    gotoShowAllShop () {
      localStorage.setItem('AllShopSearch', Encode.encode(this.shopSearchShow))
      this.$router.push(`/search-shop/${this.textSearch}`).catch(() => {})
    }
  }
}
</script>

<style scoped>
.v-breadcrumbs {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  flex: 0 1 auto;
  list-style-type: none;
  margin: 0;
  padding: 0px 0px 0px 0px !important;
}
.container {
  max-width: 1250px !important;
}
.v-btn-toggle--group > .v-btn.v-btn {
  background-color: transparent !important;
  border-color: transparent;
  margin: 0px !important;
  min-width: auto;
}
</style>
